"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  callout: {
    heading: 'leadFlowEditor.leadFlowCalloutEditor.calloutTextHeader',
    description: 'leadFlowEditor.leadFlowCalloutEditor.bodyTextHeader',
    cta: 'leadFlowEditor.leadFlowCalloutEditor.buttonTextHeader',
    color: 'leadFlowEditor.leadFlowCalloutEditor.themeColorPickerHeader'
  },
  form: {
    imageFileName: 'leadFlowEditor.leadFlowFormEditor.featuredImage',
    formDescription: 'leadFlowEditor.leadFlowFormEditor.bodyTextHeader',
    formFields: 'leadFlowEditor.leadFlowFormEditor.includedFieldsSelectionHeader',
    formCta: 'leadFlowEditor.leadFlowFormEditor.buttonTextHeader',
    legalConsentOptions: 'leadFlowEditor.leadFlowFormEditor.formGDPRSelector.header',
    locale: 'leadFlowEditor.leadFlowFormEditor.formLanguageSelectorHeader',
    lifecycle: 'leadFlowEditor.leadFlowFormEditor.formLifecycleSelectorHeader'
  },
  thanks: {
    completedMessageHtml: 'leadFlowEditor.leadFlowThankYouMessage.thankYouMessageHeader',
    redirectButtonType: 'leadFlowEditor.leadFlowThankYouMessage.thankYouButton',
    redirectButtonText: 'leadFlowEditor.leadFlowThankYouMessage.redirectButtonText'
  },
  'follow-up': {
    kickbackEmails: 'leadFlowEditor.leadFlowFollowUpEmailEditor.followUpEmailTitle'
  },
  options: {
    targetingOptions: 'leadFlowEditor.leadFlowOptionsEditor.targetingOptions.name',
    displayOnScroll: 'leadFlowEditor.leadFlowOptionsEditor.triggers.flowTriggers',
    displayOnExitIntent: 'leadFlowEditor.leadFlowOptionsEditor.triggers.flowTriggers',
    displayOnTimedDelay: 'leadFlowEditor.leadFlowOptionsEditor.triggers.flowTriggers',
    publishAt: 'leadFlowEditor.leadFlowOptionsEditor.scheduling.scheduling',
    unpublishAt: 'leadFlowEditor.leadFlowOptionsEditor.scheduling.scheduling',
    displayOnMobile: 'leadFlowEditor.leadFlowOptionsEditor.smallScreenSizes',
    ignoreDurationDays: 'leadFlowEditor.leadFlowOptionsEditor.ignoreDuration',
    notificationEmails: 'leadFlowEditor.leadFlowOptionsEditor.emailNotifications.header'
  },
  audience: {
    audience: 'leadFlowEditor.leadFlowOptionsEditor.targetingOptions.name'
  }
};
exports.default = _default;
module.exports = exports.default;